// extracted by mini-css-extract-plugin
module.exports = {"text":"text__2hF4B","label":"label__1rvJu","button":"button__224Q8","box-wrapper":"box-wrapper__8aPoe","box":"box__vn3iP","foot-note":"foot-note__181xS"};